module.exports = __webpack_public_path__ + "static/media/IMG_3564.8a10a2ba.jpg";